export default "__VITE_ASSET__73e79dce__"